export default "/images/vendor/flag-icon-css/flags/4x3/xx.svg?83395f32486800ebce5eac609b5d6f8d";